<template>
    <GChart
        :type="chartType"
        :data="chartData"
        :options="chartOptions"
        ref="gChart"
        @ready="onChartReady"
        class="chart"
        :settings="{packages: ['corechart', 'table', 'geochart']}"
    />
</template>

<style lang="scss">
    .chart {
        height: 100%;
    }

    .contrast .google-visualization-tooltip {
        background: rgb($tertiary-color);
        .chart-tooltip {
            color: rgb($quinary-color);
        }
    }

</style>

<script>
import { GChart } from 'vue-google-charts'
 
export default {
    name: "googleChart",
    // props: ["type", "data", "options"],
    components: {
        GChart
    },
    data() {
        return {
            chartType: '',
            chartData: [],
            chartOptions: {},
        }
    },
    methods: {
        onChartReady (chart, google) {
             if (this.chartOptions.tooltip.trigger == 'selection') {
                document.getElementById('app').arrive('.tooltip-close', function() {
                    this.onclick = function(e) {
                        e.preventDefault();
                        chart.setSelection([{}]);
                    }
                });
            }
        }
    }

}
</script>